export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pt-32 pb-24">
      <section className="max-w-[900px] mx-auto px-6 lg:px-12">
        <p className="label-overline text-zinc-500">Legal</p>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter font-light mt-4">Privacy policy.</h1>
        <p className="text-zinc-500 mt-2 text-sm">Last updated: December 2025</p>

        <div className="mt-12 prose prose-zinc max-w-none space-y-8 text-zinc-700 leading-relaxed">
          <Section title="1. Who we are">
            <p>
              Ege Models ("we", "us", "the agency") is a modeling agency based at Puck van Heelstraat 142, 3077 MG Rotterdam, the Netherlands.
              We are the data controller for personal data collected through this website,
              <span className="font-mono"> egemodels.com</span>.
            </p>
            <p>For data protection requests, contact <a href="mailto:privacy@egemodels.com" className="link-underline">privacy@egemodels.com</a>.</p>
          </Section>

          <Section title="2. What data we collect">
            <ul className="list-disc list-inside space-y-2">
              <li><b>Booking & contact forms:</b> name, email, phone, company, project brief, dates and budget.</li>
              <li><b>Model applications:</b> name, email, phone, age, gender, location, height, photos, biography, experience.</li>
              <li><b>Cookies / analytics:</b> if you accept analytics, anonymised page views via a privacy-friendly analytics tool.</li>
            </ul>
          </Section>

          <Section title="3. Why we use your data">
            <p>To respond to bookings and inquiries, evaluate model applications, and improve the site. We never sell your data.</p>
          </Section>

          <Section title="4. How long we keep it">
            <p>Booking and contact submissions: up to 24 months unless we have an active engagement. Model applications: up to 24 months from submission.</p>
          </Section>

          <Section title="5. Your rights (GDPR)">
            <p>If you are in the EU/EEA you have the right to access, correct, delete, restrict or port your personal data, and to object to processing. Contact us to exercise these rights.</p>
          </Section>

          <Section title="6. Cookies">
            <p>This site uses essential cookies to function. With your consent, we also use anonymised analytics to understand how visitors use the site. No advertising or third-party tracking cookies are set.</p>
          </Section>

          <Section title="7. Children">
            <p>Our service is not directed to children under 16. Applicants under 18 must apply with parental consent.</p>
          </Section>

          <Section title="8. Updates">
            <p>We may revise this policy. Material changes will be communicated on this page.</p>
          </Section>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-serif text-2xl mb-3 text-black">{title}</h2>
      {children}
    </div>
  );
}
